import { Typography } from "@mui/material";
import LegalPageLayout from "./LegalPageLayout";

export default function TermsPage() {
  return (
    <LegalPageLayout title="Terms of Service" updatedAt="August 9, 2026">
      <Typography variant="body1">
        These Terms of Service ("Terms") govern your access to and use of the Athriv Asset Portal
        ("Service"), provided by Athriv Technologies ("Athriv", "we", "us"). By creating an account
        or using the Service, you agree to these Terms on behalf of yourself and the organization
        you represent ("Customer").
      </Typography>

      <Typography component="h2">1. The Service</Typography>
      <Typography>
        The Service is a multi-tenant asset management platform that lets Customer track, assign,
        transfer, and maintain physical assets, and manage related approvals, notifications, and
        reports. Each Customer's data is logically isolated from every other Customer.
      </Typography>

      <Typography component="h2">2. Accounts and Access</Typography>
      <Typography>
        Customer is responsible for all activity under its account, for keeping login credentials
        confidential, and for ensuring that only authorized users are invited to its tenant.
        Customer may sign in via Microsoft single sign-on or an email/password account, depending
        on how its tenant is configured.
      </Typography>

      <Typography component="h2">3. Customer Data</Typography>
      <Typography>
        Customer retains all rights to the data it submits to the Service ("Customer Data"). We
        use Customer Data only to provide and support the Service, and will not access it except
        as needed to operate the Service, respond to support requests, or as required by law.
        Customer may export its data at any time, and may permanently delete its account and all
        associated data using the account-deletion feature in Settings.
      </Typography>

      <Typography component="h2">4. Acceptable Use</Typography>
      <Typography>
        Customer will not use the Service to store unlawful content, attempt to breach the
        Service's security, interfere with other tenants, or reverse-engineer the Service except
        as permitted by law.
      </Typography>

      <Typography component="h2">5. Availability and Support</Typography>
      <Typography>
        We aim to keep the Service available and reliable but do not guarantee uninterrupted
        access. We may perform maintenance that temporarily affects availability, with notice
        where practical.
      </Typography>

      <Typography component="h2">6. Fees</Typography>
      <Typography>
        Fees, if any, for paid plans are described at the time of purchase. Fees are
        non-refundable except where required by law.
      </Typography>

      <Typography component="h2">7. Termination</Typography>
      <Typography>
        Customer may stop using the Service and delete its account at any time. We may suspend or
        terminate access for material breach of these Terms, including non-payment or abuse of
        the Service.
      </Typography>

      <Typography component="h2">8. Disclaimer and Liability</Typography>
      <Typography>
        The Service is provided "as is" without warranties of any kind. To the maximum extent
        permitted by law, Athriv is not liable for indirect, incidental, or consequential damages
        arising from use of the Service.
      </Typography>

      <Typography component="h2">9. Changes to These Terms</Typography>
      <Typography>
        We may update these Terms from time to time. Continued use of the Service after an update
        constitutes acceptance of the revised Terms.
      </Typography>

      <Typography component="h2">10. Contact</Typography>
      <Typography>
        Questions about these Terms can be sent to legal@athriv.com.
      </Typography>
    </LegalPageLayout>
  );
}
